import React, {useState, useEffect} from 'react';

const ANIMATION_STORAGE_KEY = 'progressBarAnimated';

function UsageProgressBar({used, total, baseColor}) {
  const usagePercentage = total > 0 ? (used / total) * 100 : 0;

  const getInitialProgress = () => {
    const hasAnimated = localStorage.getItem(ANIMATION_STORAGE_KEY) === 'true';
    return hasAnimated ? usagePercentage : 0;
  };

  const [animatedProgress, setAnimatedProgress] = useState(getInitialProgress);

  useEffect(() => {
    if (animatedProgress !== usagePercentage) {
      const timer = setTimeout(() => {
        setAnimatedProgress(usagePercentage);
        localStorage.setItem(ANIMATION_STORAGE_KEY, 'true');
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [usagePercentage, animatedProgress]);

  const animatedLabelText = `${Math.round(animatedProgress)}% Used`;
  const fadeThreshold = 85;

  return (
    <>
      <div className="w-full bg-[#F9F9F9] rounded-full h-2.5 mb-2">
        <div
          className="h-2.5 rounded-full"
          style={{
            width: `${animatedProgress}%`,
            backgroundColor: baseColor || '#3f7cdb',
            transition: 'width 1.2s ease-out',
          }}
        ></div>
      </div>

      <div className="relative w-full text-xs text-[#1D2739] mb-4 h-4">
        {used === 0 && <span className="absolute left-0">0%</span>}
        {used > 0 && (
          <span
            className="absolute"
            style={{
              left: `${animatedProgress}%`,
              transform: 'translateX(-50%)',
              transition: 'left 1.2s ease-out',
            }}
          >
            {animatedLabelText}
          </span>
        )}

        <span
          className={`absolute right-0 transition-opacity duration-300 ${
            animatedProgress > fadeThreshold ? 'opacity-0' : 'opacity-100'
          }`}
        >
          100%
        </span>
      </div>
    </>
  );
}

export default UsageProgressBar;
